import { render } from "./branch-modal.vue?vue&type=template&id=b9646300"
import script from "./branch-modal.vue?vue&type=script&lang=js"
export * from "./branch-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__